module.exports = __webpack_public_path__ + "static/img/013酒庄官网4.2c9743e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/013酒庄官网4.jpg
// module id = fnyq
// module chunks = 0